<template>
    <div>
        <mt-header :title="title" style="position: fixed;left:0px;right:0px;top:0px;">
            <div slot="left">
                <mt-button icon="back" @click="$router.go(-1)"> </mt-button>
            </div>
            <mt-button icon="more" slot="right"></mt-button>
        </mt-header>
       <p style="height:1px"  ref="header"></p>
        <ul
                :style="{'height':curHeight,'width':'100%','margin':'0px','padding':' 0px','overflow': 'auto'}"
        >
            <article id="policy1" >
                <p style="height:30px"></p>
                <ul style="padding:0px;margin:0px">
                    <li  style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div class="list_card">
                            <div class="first_text" style="padding:0.3rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                                <p style="font-weight: bold">基本资料</p>
                                <p style="text-align: right"></p>
                            </div>
                            <div style="color:#969696" class="content_text">
                                <div>
                                    <p>保单号码</p><p>{{policy.policyNo}}</p>
                                </div>
                                <div>
                                    <p>投保日期</p><p>{{getDate2(policy.submitDate)}}</p>
                                </div>
                                <div>
                                    <p>保险公司</p><p>{{getInsurance(policy.insuranceId)}}</p>
                                </div>
                                <div>
                                    <p>状态</p><p>{{getStatus(policy.status)}}</p>
                                </div>
                                <div>
                                    <p>缴款模式</p><p>{{getPayterm(policy.payTerm)}}</p>
                                </div>
                                <div>
                                    <p>保單日期</p><p>{{getDate2(policy.policyDate)}}</p>
                                </div>
                                <div>
                                    <p>冷静期日期</p><p>{{getDate2(policy.coolingOffDate)}}</p>
                                </div>
                                <div>
                                    <p>首期保费日</p><p>{{getDate2(policy.premiumDate)}}</p>
                                </div>
                                <div>
                                    <p>签发日期</p><p>{{getDate2(policy.issueDate)}}</p>
                                </div>
                                <div>
                                    <p>货币</p><p>{{getCurrency(policy.currencyId)}}</p>
                                </div>
                                <div>
                                    <p>首年总保费</p><p>{{policy.appPremium|currency('')}}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </article>
            <article id="policy2">
                <p style="height:20px"></p>
                <ul style="padding:0px;margin:0px">
                    <li  style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div class="list_card">
                            <div class="first_text" style="padding:0.3rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                                <p style="font-weight: bold">参与人员</p>
                                <p style="text-align: right"></p>
                            </div>
                            <div style="color:#969696" class="content_text">
                                <div>
                                    <p>合作伙伴</p><p>{{policy.partnerName}}</p>
                                </div>
                                <div>
                                    <p>业务代表</p><p>{{policy.trName}}</p>
                                </div>
                                <div>
                                    <p>业务代表2</p><p>{{policy.tr2Name}}</p>
                                </div>
                                <div>
                                    <p>服务代表</p><p>{{policy.serviceName}}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li style="text-align: center"><i v-if="loading" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i></li>
                </ul>
            </article>
            <article id="policy3">
                <p style="height:20px"></p>
                <ul style="padding:0px;margin:0px">
                    <li  style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div class="list_card">
                            <div class="first_text" style="padding:0.3rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                                <p style="font-weight: bold">产品资料</p>
                                <p style="text-align: right"></p>
                            </div>
                            <div v-for="item in productList" style="color:#969696;border-bottom: 1px solid gray" class="content_text">
                                <div>
                                    <p>種類</p><p>{{item.type}}</p>
                                </div>
                                <div>
                                    <p>产品</p><p>{{item.nameTw}}</p>
                                </div>
                                <div>
                                    <p>年期</p><p>{{item.periodName}}</p>
                                </div>
                                <div>
                                    <p>保额</p><p>{{item.sumInsured|currency('')}}</p>
                                </div>
                                <div>
                                    <p>保费</p><p>{{item.subPremium|currency('')}}</p>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </article>
            <article id="policy4">
                <p style="height:20px"></p>
                <ul style="padding:0px;margin:0px">
                    <li  style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div class="list_card">
                            <div class="first_text" style="padding:0.3rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                                <p style="font-weight: bold">客户资料</p>
                                <p style="text-align: right"></p>
                            </div>
                            <div style="color:#969696;border-bottom: 1px solid gray" v-for="item2 in policy.customerList" class="content_text">
                                <div>
                                    <p>种类</p><p>
                                    <span v-if="item2.applicant==1">持有人</span>
                                    <span v-if="item2.applicant==1&&item2.insured==1">, </span>
                                    <span v-if="item2.insured==1">被保人</span>
                                    <span v-if="item2.beneficiary==1&&item2.insured==1">, </span>
                                    <span v-if="item2.beneficiary==1&&item2.applicant==1">, </span>
                                    <span v-if="item2.beneficiary==1">受益人</span>
                                </p>
                                </div>
                                <div>
                                    <p>中文姓名</p><p>{{item2.customerOption[0].nameChi}}</p>
                                </div>
                                <div>
                                    <p>英文姓名</p><p>{{item2.customerOption[0].nameEng}}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li style="text-align: center"><i v-if="loading" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i></li>
                </ul>
            </article>
            <article id="policy5">
                <p style="height:20px"></p>
                <ul style="padding:0px;margin:0px">
                    <li style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div class="list_card">
                            <div class="first_text" style="padding:0.3rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                                <p style="font-weight: bold">跟进资料</p>
                                <p style="text-align: right"></p>
                            </div>
                            <div style="color:#969696;border-bottom: 1px solid gray" v-for="policyRemark in policy.policyRemarkList" class="content_text">
                                <div>
                                    <p>建立日期</p><p>{{getDate2(policyRemark.createDate)}}</p>
                                </div>
                                <div>
                                    <p>内容</p><p>{{policyRemark.content}}</p>
                                </div>
                                <div>
                                    <p>期限</p><p>{{getDate2(policyRemark.deadLine)}}</p>
                                </div>
                                <div>
                                    <p>完成日期</p><p>{{getDate2(policyRemark.solvedDate)}}</p>
                                </div>

                            </div>
                        </div>
                    </li>
                </ul>
            </article>
            <article id="policy6" >
                <p style="height:20px"></p>
                <ul style="padding:0px;margin:0px">
                    <li style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                        <div class="list_card">
                            <div class="first_text" style="padding:0.3rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                                <p style="font-weight: bold">续保资料</p>
                                <p style="text-align: right"></p>
                            </div>
                            <div style="color:#969696" class="content_text">
                                <div>
                                    <p>下期缴费日期</p><p>{{getDate2(policy.nextPremiumDate)}}</p>
                                </div>
                                <div>
                                    <p>自动转账</p><p>
                                    <span v-if="policy.isAutoPay==1">已設定</span>
                                    <span v-else>未設定</span></p>
                                </div>
                                <div>
                                    <p>绑定户口</p><p></p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li style="text-align: center"><i v-if="loading" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i></li>
                </ul>
            </article>
            <div :class="style==''?'sear_list sear':'sear_list'"  >
                <div style="background: rgb(38, 162, 255); position: absolute;left: -22px;line-height: 18px; top: 42%; width: 35px; height: 35px;border-radius: 50%" @click="getSearch()"><i  :class=" style==''?'iconfont icon-youjiantou':'iconfont icon-youjiantou-copy'"></i></div>
                <div id="quckicy">
                    <div @click="goAnchor('#policy1')">基本资料</div>
                    <div @click="goAnchor('#policy2')">参与人员</div>
                    <div @click="goAnchor('#policy3')">产品资料</div>
                    <div @click="goAnchor('#policy4')">客户资料</div>
                    <div @click="goAnchor('#policy5')">跟进资料</div>
                    <div @click="goAnchor('#policy6')">续保资料</div>
                </div>

            </div>
        </ul>

    </div>
</template>
<script>
    import router from '@/router/router'
    import axios from 'axios'
    import {queryPolicyList,validPolicyNo,insertPolicy,queryPolicyById,queryStaffByStaffType,queryRemarkOption,
        updatePolicy,queryInsuranceOption,queryProductOption,queryProductPeriodOption,queryCurrencyOption,queryCustomerOption,queryFileSubTypeOption,
        policyFileUpload,initialPolicyUploadFileList,delFileById,queryOneUploadFileById,queryListBySourceIdAndType,updateUploadFile,queryOptionMyPolicy,
        queryTrOption,queryTr2Option,queryServiceOption,imageUrl,validPolicyPwd,queryMyUserPolicyList}
        from '../../api/api'

    export default {
        data(){
            return{
                title:'',
                style:'',
                curHeight:'',
                value:'',
                loading:false,
                list:[1,2,3],
                searchName:'',
                searchInsuranceId:'',
                searchStatus:'',
                searchCustName:'',
                searchPartner:'',
                searchSubmitDate:'',
                searchPayTerm:'',
                searchIsAutoPay:'',
                searchProductName:'',
                searchGroup:'',
                searchTrId:'',
                searchTr2Id:'',
                searchServiceId:'',
                moreSearch:false,
                policyList:[],
                policyTableloading:false,
                policyFormloading:false,
                pager:{
                    page:1,
                    size:10,
                    total:0
                },
                dialogName:'',
                policyFromVisible:false,
                policyRules: {
                    submitDate: [
                        {required: true, message: "請選擇投保日期", trigger: 'change' },
                    ],
                    insuranceId: [
                        {required: true, message: "請選擇保險公司", trigger: 'change' },
                    ],
                    payTerm: [
                        {required: true, message: "請選擇繳費模式", trigger: 'change' },
                    ],
                    currencyId: [
                        {required: true, message: "請選擇貨幣", trigger: 'change' },
                    ],
                    productId: [
                        {required: true, message: "請選擇主計劃", trigger: 'change' },
                    ],
                    periodId: [
                        {required: true, message: "請選擇主計劃年期", trigger: 'change' },
                    ],
                },
                policy:{
                    id:"",rev:"",policyNo:"",insuranceId:"",productId:"",periodId:"",partnerId:"",trId:"",tr2Id:"",serviceId:"",
                    submitDate:"",payTerm:"",currencyId:"",sumInsured:"",subPremium:"",recPremium:"",appPremium:"",policyDate:"",
                    premiumDate:"",coolingOffDate:"",status:0,policyStatus:1,isComm:0,isAutoPay:0,nextPremiumDate:"",levy:"",
                    nextPremium:"",remark:""
                },
                staffList:[],
                policyStaffloading:false,
                insuranceOption:[],
                productOption:[],
                productPeriodOption:[],
                currencyOption:[],
                serviceOption:[],
                tr2Option:[],
                trOption:[],
                childValue:'',
                partnerOption:[],
                customerList:[],
                policyCust:{id:"",policyId:"",clientId:"",insured:"",applicant:"",beneficiary:"",customerOption:[],index:0},
                payTermOption:[
                    //繳費方式, 1:年繳, 2:半年繳, 3:季繳, 4:月繳, 5:一次性付清
                    {label:'年繳',value:1},{label:'半年繳',value:2},{label:'季繳',value:3},{label:'月繳',value:4},{label:'一次性付清',value:5}
                ],
                statusOption:[
                    //狀態, 0:處理中, 1:存檔, 2: 終止申請, 3. 冷靜期退保, 4: 生效, 5:轉出保單, 6: 保單失效
                    {label:'處理中',value:0},{label:'存檔',value:1},{label:'終止申請',value:2},{label:'冷靜期退保',value:3},
                    {label:'生效',value:4},{label:'轉出保單',value:5},{label:'保單失效',value:6},{label:'擱置',value:7},
                    {label:'拒保',value:8},{label:'廢除',value:9},{label:'不完整',value:10},{label:"退保",value:11},
                    {label:'不接受',value:12},{label:'其他',value:13},{label:'撤銷',value:14},{label:'基本保費繳足和附加契約生效',value:15},
                    {label:'未處理初始保費',value:16},{label:'已終止-主要索賠',value:18},
                    {label:'由於死亡, 保費被免除',value:19},{label:'由於殘廢，保費被免除',value:20},
                    {label:'首期保費未曾生效/退回 (例如冷靜期退保，保單撤回)',value:21}
                ],
                searchStatusOption:[
                    {label:'處理中',value:0},{label:'存檔',value:1},{label:'終止申請',value:2},{label:'冷靜期退保',value:3},
                    {label:'生效',value:4},{label:'轉出保單',value:5},{label:'保單失效',value:6},{label:'擱置',value:7},
                    {label:'拒保',value:8},{label:'廢除',value:9},{label:'不完整',value:10},{label:"退保",value:11},
                    {label:'不接受',value:12},{label:'其他',value:13},{label:'撤銷',value:14},{label:'基本保費繳足和附加契約生效',value:15},
                    {label:'未處理初始保費',value:16},{label:'已終止-主要索賠',value:18},
                    {label:'由於死亡, 保費被免除',value:19},{label:'由於殘廢，保費被免除',value:20},
                    {label:'首期保費未曾生效/退回 (例如冷靜期退保，保單撤回)',value:21},
                    {label:'處理中有跟進事項',value:-1},{label:'保單服務跟進事項',value:-2}
                ],
                policyStatusOption:[
                    //狀態2 : 0: 預先核保, 1: 正常, 2:正行使保費假期, 3:轉入保單, 4: 期滿
                    {label:'預先核保',value:0},{label:'正常',value:1},{label:'正行使保費假期',value:2},{label:'轉入保單',value:3},
                    {label:'期滿',value:4}
                ],
                currentCustomerIndex:"",
                delPolicyCustList:[],
                policyRiderList:[],
                policyRider:{id:"",policyId:"",productId:"",productPeriodId:"",premium:"",sumInsured:"",productOption:[],productPeriodOption:[],index:0},
                currencyPolicyRiderIndex:"",
                currencyPolicyRemarkIndex:"",
                delPolicyRiderList:[],
                policyRemarkList:[],
                policyRemark:{id:"",policyId:"",content:"",solvedDate:"",deadLine:"",createDate:"",index:0},
                policyRemarkOption:[],
                delPolicyRemarkList:[],
                expandPolicyRow:[],

                //file upload
                fileListView:false,
                fileList:[],
                fileUploadView:false,
                uploadFile:{id:"",fileUrl:"",fileName:"",sourceId:"",sourceType:"",sourceSubType:"",description:"",relativePath:"",file:[]},
                //end file upload
                fileSubTypeOption:[],
                uploadFileList:[],
                fileUploadLoading:false,
                policyId:"",
                sourceType:"",
                fileApp:1,
                filePen:2,
                filePol:3,
                filePos:4,
                appFileList:[],
                penFileList:[],
                polFileList:[],
                posFileList:[],
                fileLoading:false,
                appPager:{
                    page:1,
                    size:10,
                    total:0
                },
                penPager:{
                    page:1,
                    size:10,
                    total:0
                },
                polPager:{
                    page:1,
                    size:10,
                    total:0
                },
                posPager:{
                    page:1,
                    size:10,
                    total:0
                },

                reverse: false,
                activities: [],
                activeNames: [],
                productList:[],
                ownerName:"",
                count:0
            }
        },
        methods:{
            getSearch(){
                if(this.style==1){
                    this.style=''
                }else {
                    this.style=1
                }
            },
            indexMethod(index){
                index = index +1;
                if(this.pager.page>1){
                    return (this.pager.size * (this.pager.page-1)) + index;
                }
                return index;
            },
            goAnchor(selector) {
                document.querySelector(selector).scrollIntoView(true);
            },
            queryServiceOption(){
                return queryServiceOption(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:serviceOption=[]}=res;
                        this.serviceOption=serviceOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryServiceOption Error");
                });
            },
            queryTr2Option(){
                return queryTr2Option(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:tr2Option=[]}=res;
                        this.tr2Option=tr2Option;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryTr2Option Error");
                });
            },
            queryTrOption(){
                return queryTrOption(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:trOption=[]}=res;
                        this.trOption=trOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryTrOption Error");
                });
            },
            queryOptionMyPolicy(){
                return queryOptionMyPolicy(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:partnerOption=[]}=res;
                        this.partnerOption=partnerOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryOptionMyPolicy Error");
                });
            },
            getCurrency(val){
                return this.currencyOption.find(v=>v.id==val).name;
            },
            getPayterm(val){
                return this.payTermOption.find(v=>v.value==val).label;
            },
            getInsurance(val){
                return this.insuranceOption.find(v=>v.id==val).nameDisplay;
            },
            //file upload
            fileDownload(val){
                if(this.$store.getters.staff.isPdfPreview){
                    let dataType = val.relativePath.substring(val.relativePath.lastIndexOf(".")+1,val.relativePath.length);
                    if(dataType=="pdf"){
                        window.open("/#/attachmentView?path="+val.relativePath, 'Preview',
                            'width=800,height=800,location=no');
                    }else if(dataType=='png'||dataType=='jpg'||dataType=='jpeg'||dataType=='bmp'||dataType=='jpe'||dataType=='dib'){
                        window.open("/#/picView?path="+val.relativePath, 'Preview',
                            'width=800,height=800,location=no');
                    }else{
                        this.$message.error("文件沒法打開, 請聯絡行政人員");
                    }
                }else{
                    window.location.href=axios.defaults.baseURL+'/file/download/?id='+val.id;
                }
            },

            changeFileType(tab, event) {
                if(tab.label==='APP'){
                    this.sourceType=this.fileApp;
                }else if(tab.label==='PEN'){
                    this.sourceType=this.filePen;
                }else if(tab.label==='POL'){
                    this.sourceType=this.filePol;
                }else if(tab.label==='POS'){
                    this.sourceType=this.filePos;
                }
            },
            queryListBySourceIdAndType(){
                let params={page:"",size:"",sourceId:this.policyId,sourceType:this.sourceType};
                switch (this.sourceType) {
                    case this.fileApp:
                        params.page=this.appPager.page;params.size=this.appPager.size;
                        break;
                    case this.filePen:
                        params.page=this.penPager.page;params.size=this.penPager.size;
                        break;
                    case this.filePol:
                        params.page=this.polPager.page;params.size=this.polPager.size;
                        break;
                    case this.filePos:
                        params.page=this.posPager.page;params.size=this.posPager.size;
                        break;
                }
                this.fileLoading=true;
                return queryListBySourceIdAndType(params).then(res=>{
                    if(res.errcode==200){
                        let {size,page,total,data:fileList=[]}=res.data;
                        switch (params.sourceType) {
                            case this.fileApp:
                                this.appFileList = fileList;this.appPager.total=total;this.appPager.page=page;
                                this.appPager.size=size;
                                break;
                            case this.filePen:
                                this.penFileList = fileList;this.penPager.total=total;this.penPager.page=page;
                                this.penPager.size=size;
                                break;
                            case this.filePol:
                                this.polFileList = fileList;this.polPager.total=total;this.polPager.page=page;
                                this.polPager.size=size;
                                break;
                            case this.filePos:
                                this.posFileList = fileList;this.posPager.total=total;this.posPager.page=page;
                                this.posPager.size=size;
                                break;
                        }
                        this.fileLoading=false;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                });
            },
            getFileSubType(val){
                if(val!=null&&val!=undefined&&val!=''){
                    return this.fileSubTypeOption.find(v=>v.id==val).label;
                }
                return "";
            },
            reUploadFileIndex(){
                this.fileList.forEach((v,i)=>{
                    v.index=i;
                })
            },
            removeUploadFileList(row){
                this.fileList.splice(row.index,1);
                this.reUploadFileIndex();
            },
            queryFileSubTypeOption(val){
                return queryFileSubTypeOption(val).then(res=>{
                    if(res.errcode==200){
                        let {data:fileSubTypeOption=[]}=res;
                        this.fileSubTypeOption=fileSubTypeOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryFileSubTypeOption Error");
                });
            },
            initalUploadFile(){
                this.uploadFile={id:0,fileUrl:null,fileName:"",sourceId:this.policyId,sourceType:this.sourceType,
                    sourceSubType:"",description:"",relativePath:null,file:[],index:this.fileList.length};
            },
            handleFileList(row){
                this.fileListView=true;
                this.policyId = row.id;
                this.sourceType = this.fileApp;
                this.appFileList=[];this.penFileList=[];this.polFileList=[];this.posFileList=[];
                let params={page:0,size:10,sourceId:this.policyId};
                initialPolicyUploadFileList(params).then(res=>{
                    if(res.errcode==200){
                        let {data:list=[]}=res;
                        if(list.length>0){
                            list.forEach((v,i)=>{
                                switch (v.sourceType) {
                                    case this.fileApp:
                                        this.appFileList.push(v);
                                        break;
                                    case this.filePen:
                                        this.penFileList.push(v);
                                        break;
                                    case this.filePol:
                                        this.polFileList.push(v);
                                        break;
                                    case this.filePos:
                                        this.posFileList.push(v);
                                        break;
                                }
                            })
                            this.appPager.total = list[0].totalList[0];
                            this.penPager.total = list[0].totalList[1];
                            this.polPager.total = list[0].totalList[2];
                            this.posPager.total = list[0].totalList[3];
                        }

                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("initialPolicyUploadFileList Error");
                });
            },
            //file upload
            remarkCol(row){
                if(row.status==0){
                    return {"color":"red"};
                }
            },
            pendingRow(row){
                if(row.row.policyRemarkList.length>0 && row.row.status==0){
                    return '';
                    //{ "background-color": "#f36262" }
                }else{
                    return '';
                }
            },
            getDate2(value){
                if(value!=''&&value!=null&&value!=undefined){
                    let d=new Date(value);
                    let m=d.getMonth()+1;
                    return d.getFullYear()+'-'+m+'-'+d.getDate();
                }
            },
            getDate(value){
                if(value!=''&&value!=null&&value!=undefined){
                    let d=new Date(value* 1000);
                    let m=d.getMonth()+1;
                    return d.getFullYear()+'-'+m+'-'+d.getDate();
                }
            },
            getRowKeys(val){
                return val.id+"";
            },
            getStatus(val){
                return this.statusOption.find(v=>v.value==val).label;
            },
            // start policy remark
            contentClick(index,val){
                this.getPolicyRemarkOptionIndex(index);
                this.policyRemarkList[this.currencyPolicyRemarkIndex].content += val;
            },
            getPolicyRemarkOptionIndex(index){
                this.currencyPolicyRemarkIndex = index;
            },
            rePolicyRemarkIndex(){
                this.policyRemarkList.forEach((v,i)=>{
                    v.index=i;
                })
            },
            queryRemarkOption(){
                return queryRemarkOption().then(res=>{
                    if(res.errcode==200){
                        let {data:policyRemarkOption=[]}=res;
                        this.policyRemarkOption=policyRemarkOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryRemarkOption Error");
                });
            },
            // end policy remark
            calTotalPremium(){
                let totalPremium=this.policy.subPremium;
                this.policyRiderList.forEach((v,i)=>{
                    totalPremium +=v.premium;
                })
                this.policy.appPremium = totalPremium;
            },
            // start Rider
            queryProductRiderPeriodOption(val){
                if(val!=''){
                    let params ={productId:val};
                    return queryProductPeriodOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productPeriodOption=[]}=res;
                            this.policyRiderList[this.currencyPolicyRiderIndex].productPeriodOption=productPeriodOption;
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductRiderPeriodOption Error");
                    });
                }
            },
            queryProductRiderOption(value){
                if(value!=''){
                    let params = {searchName:value,insuranceId:this.policy.insuranceId,productOption:3}
                    return queryProductOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productOption=[]}=res;
                            this.policyRiderList[this.currencyPolicyRiderIndex].productOption=productOption;
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductRiderOption Error");
                    });
                }
            },
            // end Rider

            // start Customer
            // end Customer
            queryPartnerOption(){
                return queryStaffByStaffType("1,2,3").then(res=>{
                    if(res.errcode==200){
                        let {data:partnerOption=[]}=res;
                        this.partnerOption=partnerOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryPartnerOption Error");
                });
            },
            queryCurrencyOption(){
                return queryCurrencyOption().then(res=>{
                    if(res.errcode==200){
                        let {data:currencyOption=[]}=res;
                        this.currencyOption=currencyOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryCurrencyOption Error");
                });
            },
            queryCustomerOption(val){
                if(val!=''){
                    let params={searchName:val,id:1}
                    return queryCustomerOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:customerOption=[]}=res;
                            this.customerList[this.currentCustomerIndex].customerOption=customerOption;
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryCustomerOption Error");
                    });
                }
            },
            queryProductPeriodOption(val){
                if(val!=''){
                    let params ={productId:val};
                    return queryProductPeriodOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productPeriodOption=[]}=res;
                            this.productPeriodOption=productPeriodOption;
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductPeriodOption Error");
                    });
                }
            },
            queryProductOption(value){
                if(value!=''){
                    let params = {searchName:value,insuranceId:this.policy.insuranceId,productOption:1}
                    return queryProductOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productOption=[]}=res;
                            this.productOption=productOption;
                        }else{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("queryProductOption Error");
                    });
                }
            },
            queryInsuranceOption(){
                return queryInsuranceOption().then(res=>{
                    if(res.errcode==200){
                        let {data:insuranceOption=[]}=res;
                        this.insuranceOption=insuranceOption;
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                }).catch((error)=>{
                    console.log("queryInsuranceOption Error");
                });
            },
            initalPolicy(){
                this.policy={
                    id:"",rev:"",policyNo:"",insuranceId:"",productId:"",periodId:"",partnerId:"",trId:"",tr2Id:"",serviceId:"",
                    submitDate:"",payTerm:"",currencyId:"",sumInsured:"",subPremium:"",recPremium:"",appPremium:"",policyDate:"",
                    premiumDate:"",coolingOffDate:"",status:0,policyStatus:1,isComm:0,isAutoPay:0,nextPremiumDate:"",levy:"",
                    nextPremium:"",remark:""
                };
                this.productOption=[];
                this.productPeriodOption=[];
                this.customerList=[];
                this.policyRiderList=[];
                this.policyRemarkList=[];
                this.policyRemarkOption=[];
                this.delPolicyCustList=[];
                this.delPolicyRiderList=[];
                this.delPolicyRemarkList=[];
                this.productList=[];
            },

            handleEdit(){
                this.activeNames=[];
                this.initalPolicy();
                return queryPolicyById(this.$route.query.uuid).then(res=>{
                    if(res.errcode==200){
                        this.policy = Object.assign({},res.data);
                        this.childValue='保單號碼：'+this.policy.policyNo
                        this.title=this.childValue
                        if(this.policy.submitDate!='' && this.policy.submitDate!=null){
                            this.policy.submitDate = this.policy.submitDate * 1000;
                        }
                        if(this.policy.policyDate!='' && this.policy.policyDate!=null){
                            this.policy.policyDate = this.policy.policyDate * 1000;
                        }
                        if(this.policy.premiumDate!='' && this.policy.premiumDate!=null){
                            this.policy.premiumDate = this.policy.premiumDate * 1000;
                        }
                        if(this.policy.nextPremiumDate!='' && this.policy.nextPremiumDate!=null){
                            this.policy.nextPremiumDate = this.policy.nextPremiumDate * 1000;
                        }
                        if(this.policy.coolingOffDate!='' && this.policy.coolingOffDate!=null){
                            this.policy.coolingOffDate = this.policy.coolingOffDate * 1000;
                        }
                        if(this.policy.issueDate!='' && this.policy.issueDate!=null){
                            this.policy.issueDate = this.policy.issueDate * 1000;
                        }
                        this.productOption = this.policy.productOption;
                        this.productPeriodOption = this.productOption[0].productPeriodList;
                        this.policyRiderList = this.policy.policyRiderList;
                        this.policyRiderList.forEach((v,i)=>{
                            v.productOption.forEach(k=>{
                                v.productPeriodOption =k.productPeriodList;
                            })
                        });

                        //customer
                        this.customerList = this.policy.customerList;
                        this.customerList.forEach((v,i)=>{
                            v.insured = v.insured.toString();
                            v.applicant = v.applicant.toString();
                            v.beneficiary = v.beneficiary.toString();
                            if(v.applicant=='1'){
                                this.ownerName = v.customerOption[0].nameEng + ", " +v.customerOption[0].nameChi
                            }
                        });


                        //remark
                        this.policyRemarkList = this.policy.policyRemarkList;
                        this.policyRemarkList.forEach((v,i)=>{
                            if(v.createDate!='' && v.createDate!=null){
                                v.createDate = v.createDate * 1000;
                            }
                            if(v.deadLine!='' && v.deadLine!=null){
                                v.deadLine = v.deadLine * 1000;
                            }
                            if(v.solvedDate!='' && v.solvedDate!=null){
                                v.solvedDate = v.solvedDate * 1000;
                            }
                        })
                        this.rePolicyRemarkIndex();
                        let item = {nameCn:this.policy.nameCn,nameTw:this.policy.nameTw,nameEng:this.policy.nameEng,periodName:
                            this.policy.productOption[0].productPeriodList.find(v=>v.id==this.policy.periodId).periodName,sumInsured:this.policy.sumInsured,
                            subPremium:this.policy.subPremium,type:"基本計劃"
                        }
                        this.productList.push(item);
                        this.policy.policyRiderList.forEach(v=>{
                            let item2 = {nameCn:v.nameCn,nameTw:v.nameTw,nameEng:v.nameEng,periodName:
                                v.productOption[0].productPeriodList.find(k=>k.id==v.productPeriodId).periodName,sumInsured:v.sumInsured,
                                subPremium:v.premium,type:"附加計劃"
                            }
                            this.productList.push(item2);
                        })

                        this.activities=[];
                        let act1 = {content:'投保',timestamp:this.getDate2(this.policy.submitDate),icon:'fa fa-pencil fa-2x'};
                        this.activities.push(act1);
                        let act2 = {content:'處理中',timestamp:this.getDate2(this.policy.submitDate),icon:'fa fa-spinner fa-2x'};
                        this.activities.push(act2);
                        let act3 = {};
                        if(this.policy.policyRemarkList.length>0){
                            act3 = {content:'跟進事項處理中',timestamp:this.getDate2(this.policy.policyRemarkList[0].createDate),icon:'fa fa-spinner fa-2x'};
                            this.activities.push(act3);
                        }
                        let act4 ={};

                        this.policy.approveDate = this.policy.policyDate;
                        if(this.policy.status == 4){
                            act4 = {content:'保單生效',timestamp:this.getDate2(this.policy.approveDate),
                                type: 'primary',
                                icon: 'fa fa-check-circle-o fa-2x'
                                /*icon: 'el-icon-circle-check-outline'*/};
                            this.activities.push(act4);
                        }
                        let act5 ={};
                        this.policy.laspeDate = this.policy.submitDate;
                        if(this.policy.status == 2){
                            act5 = {content:'終止申請',timestamp:this.getDate2(this.policy.laspeDate),
                                type: 'primary',
                                icon: 'el-icon-circle-close-outline'};
                            this.activities.push(act5);
                        }
                        let act6 ={};
                        if(this.policy.status == 5){
                            act6 = {content:'轉出保單',timestamp:this.getDate2(this.policy.laspeDate),
                                type: 'primary',
                                icon: 'el-icon-circle-close-outline'};
                            this.activities.push(act6);
                        }

                        let act7 ={};
                        if(this.policy.status == 6){
                            act7 = {content:'保單失效',timestamp:this.getDate2(this.policy.laspeDate),
                                type: 'primary',
                                icon: 'el-icon-circle-close-outline'};
                            this.activities.push(act7);
                        }
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                });
            },
            queryPolicyList(){
                this.policyTableloading=true;
                var params={page:this.pager.page,size:this.pager.size,searchName:this.searchName,
                    insuranceId:this.searchInsuranceId,status:this.searchStatus,custName:this.searchCustName,
                    partnerId:this.searchPartner,payTerm:this.searchPayTerm,
                    isAutoPay:this.searchIsAutoPay,productName:this.searchProductName,
                    trId:this.searchTrId,tr2Id:this.searchTr2Id,serviceId:this.searchServiceId,
                    staffId:this.$store.getters.staff.id};
                if(this.searchSubmitDate!='' && this.searchSubmitDate!=null){
                    params.submitDate = this.searchSubmitDate/1000;
                }
                return queryMyUserPolicyList(params).then(res=>{
                    if(res.errcode==200){
                        let {size,page,total,data:policyList=[]}=res.data;
                        this.policyList=policyList;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.policyTableloading=false;
                        this.policyList.forEach(v=>{
                            if(v.policyRemarkList.length>0 && v.status!=2){
                                this.expandPolicyRow.push(v.id);
                            }
                        })
                    }else{
                        this.$toast({
                            message: res.errmsg,
                            position: 'center',
                            color:'red',
                            duration: 5000
                        });
                    }
                });
            },
            goAnchor(selector) {
                document.querySelector(selector).scrollIntoView(true);
            },
            handleCurrentChange(val){
                this.queryPolicyList();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },

            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            loadMore() {

            },
            handleClose(){

            },
        },
        created() {
            this.handleEdit()
        },
        mounted() {
            this.queryPolicyList();
            const that = this
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight
                    that.fullHeight = window.fullHeight
                })() }
            this.queryFileSubTypeOption(1);
            this.queryInsuranceOption();
            this.queryCurrencyOption();
            this.queryOptionMyPolicy();
            this.queryTrOption();
            this.queryTr2Option();
            this.queryServiceOption();
            this.queryRemarkOption();

        },
        activated(){
                this.queryPolicyList();
        },
    }
</script>
<style scoped>
    #quckicy div{
    padding:5px 10px;
    }
    #quckicy{
        background: #26a2ff;
        color: #FFFFFF;
    }
    .sear_list div:nth-child(1){
        padding: 10px 0px;
    }
    .icon-youjiantou{
        font-size:20px;
        color: white;
    }
.icon-youjiantou-copy{
    font-size:20px;
    color: white;
}
 .list_card p:nth-child(1){
     display: inline-block;
     width:30%;
 }
 .list_card p:nth-child(2){
     display: inline-block;
     width:68%;
     text-align: right;
     vertical-align: middle;

 }
 .first_text{
     font-size:0.39rem;
     font-weight: bold!important;
     padding:6px 0px;
 }
 .list_card{
     padding: 0rem 0.3rem;
     background: #FFFFFF;
     width:93%;
     margin:0rem auto;
 }
 .first_text p:nth-child(1){

 }
 .first_text p:nth-child(2){

 }
 .sear_list{
     position: fixed;
     z-index: 888;
     background: #FFFFFF;
     top:30%;
     right:0rem;
     transition: all 0.5s;
 }
 .sear{
     top:30%;
     right:-76px;
     transition: all 0.5s;
 }
 .mint-search{
     height:44px!important;
 }
 .content_text div{
     padding:0.15rem 0rem!important;
 }
 .mint-cell{
     height:33px!important;
 }
 .mint-cell  .mint-cell-wrapper{
     font-size: 0.17rem!important;
     font-weight: bold!important;
 }
</style>



// WEBPACK FOOTER //
// src/views/mobile/policyDetail.vue